import { SetStyles } from "../../MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { FreegameBonusFactory2, FreegameBonus2, FreegameBonus2Params } from "../FreegameBonus/FreegameBonus2";
import { FreegamesCommonConfiguration } from "../../api";
import { FreegameSession } from "../FreegameBonus/FreegameSession";
import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
import { FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
import { SlotGameType1_2 } from "../SlotGameType1_2";

export class JubileeSevenFever2 extends SlotGameType1_2 {
    protected override seconScreenHelpFactory: ISlideFactoryGeneric = new FactoryDoubleSlide();
    ////protected override freegameBonusFactory: FreegameBonusFactory2 = new JubileeSevenFever2Freegame2BonusFactory();

    // public PrepareFont(resourceManager: ResourceManager)
    // {
    //  resourceManager.Add(new FontResource(this.basepath + "resources/WildNature.ttf",this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
    // }
}

class JubileeSevenFever2Freegame extends FreegameBonus2 {



    public override async ResourcesLoaded(loadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
       await super.ResourcesLoaded(loadingStage, resourceManager);

        SetStyles(this.view.querySelectorAll(".bonustitle"), {
            color: "#FFFFFF",
            textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",
        });
        SetStyles(this.view.querySelectorAll(".total-win"), {
            color: "#FFFFFF",
            textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",
        });
        SetStyles(this.view.querySelectorAll("#left"), {
            color: "#FFFFFF",
            textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",
        });
        SetStyles(this.view.querySelectorAll("#won"), {
            color: "#FFFFFF",
            textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",
        });
        SetStyles(this.view.querySelectorAll("#played"), {
            color: "#FFFFFF",
            textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",
        });
        SetStyles(this.view.querySelectorAll(".freegames-num-value"), {
            color: "#FFFFFF",
            textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",
        });
        SetStyles(this.view.querySelectorAll(".freegames-left-value"), {
            color: "#FFFFFF",
            textShadow: "#FF4081 0px 0px 10px, #FF4081 0px 0px 20px, #FF4081 0px 0px 30px, #FF4081 0px 0px 40px",
        });
    }   

}
class JubileeSevenFever2Freegame2BonusFactory extends FreegameBonusFactory2 {
    public override CreateFreegameBonus2(gameName: ResourceIdentifier, freeGameConfig: FreegamesCommonConfiguration, p: FreegameBonus2Params): FreegameBonus2 {
        return new JubileeSevenFever2Freegame(gameName, freeGameConfig, p);
    }
}